export default __webpack_public_path__ + "static/Email-965fa88dd1a08f81e5fc5cb025f06bef.svg";